/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/FormatterAPI',
	'../../../util/DashboardFormatter'
], (APIFactory, FormatterAPI, DefaultFormatter) => {

	// client-side formatter
	class Formatter {

		constructor() {
			this._api = APIFactory.createAPI(this, [FormatterAPI]);
			this._providers = new Map();

			// set default formatter
			this._providers.set(undefined, DefaultFormatter);
		}

		destroy() {
			this._api = null;
			this._providers.clear();
			this._providers = null;
		}

		getAPI() { return this._api; }

		registerProvider(type, provider) {
			this._providers.set(type, provider);
		}

		format(value, spec) {
			// use default formatter
			return this._providers.get(undefined).format(value, spec);
		}

	}

	return Formatter;
});